(() => {
  if (window.__rwWishInit) return;
  window.__rwWishInit = true;

  const storageKey = 'rw_wishlist';

  const getList = () => {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey) || '[]');
    } catch (_error) {
      return [];
    }
  };

  const saveList = (list) => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(list));
    } catch (_error) {
      // A blocked localStorage should not prevent navigation or purchasing.
    }
  };

  const isWished = (id) => getList().some((item) => String(item.id) === String(id));

  const setButtonState = (button, active) => {
    button.classList.toggle('is-wished', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'お気に入りから削除' : 'お気に入りに追加');
  };

  const updateCounter = () => {
    const count = getList().length;
    document.querySelectorAll('.rw-wish-counter').forEach((counter) => {
      counter.textContent = count > 0 ? String(count) : '';
      counter.style.display = count > 0 ? 'flex' : 'none';
    });
  };

  const updateAll = () => {
    document.querySelectorAll('.rw-wish-btn').forEach((button) => {
      setButtonState(button, isWished(button.dataset.wishId));
    });
    updateCounter();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.rw-wish-btn');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const id = button.dataset.wishId;
    const list = getList();
    const index = list.findIndex((item) => String(item.id) === String(id));

    if (index >= 0) {
      list.splice(index, 1);
    } else {
      list.push({
        id,
        title: button.dataset.wishTitle,
        url: button.dataset.wishUrl,
        img: button.dataset.wishImg,
        price: button.dataset.wishPrice,
      });
    }

    saveList(list);
    updateAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }
})();
